import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2, Users, Stethoscope, FlaskConical, Mic, Dna, ScrollText, ArrowRight } from "lucide-react";

export default function AdminOverview() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);
  if (!stats) return <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-brand" /></div>;

  const cards = [
    { label: "Patients", value: stats.patients, icon: Users, c: "#1E3A8A" },
    { label: "Clinicians", value: stats.clinicians, icon: Stethoscope, c: "#3B82F6" },
    { label: "Lab partners", value: stats.labs, icon: FlaskConical, c: "#0EA5E9" },
    { label: "Voice sessions", value: stats.voice_sessions, icon: Mic, c: "#8B5CF6" },
    { label: "Active genetic tests", value: stats.active_tests, icon: Dna, c: "#B45309" },
    { label: "Audit events", value: stats.audit_events, icon: ScrollText, c: "#15803D" },
  ];

  return (
    <div>
      <div className="eyebrow">Administration</div>
      <h1 className="font-head text-3xl font-bold text-ink mt-1">Platform overview</h1>
      <p className="text-ink-soft mt-1">Users, screening activity and audit across the pilot.</p>

      <div className="mt-6 grid grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map((s) => (
          <div key={s.label} className="rounded-xl border border-slate-200 bg-white p-5 card-lift">
            <s.icon className="h-6 w-6 mb-3" style={{ color: s.c }} />
            <div className="mono text-3xl font-semibold text-ink">{s.value}</div>
            <div className="eyebrow mt-1">{s.label}</div>
          </div>
        ))}
      </div>

      <div className="mt-8 grid sm:grid-cols-3 gap-4">
        {[
          { to: "/admin/users", label: "Manage users", icon: Users },
          { to: "/admin/mapping", label: "Configure test mapping", icon: Dna },
          { to: "/admin/audit", label: "View audit log", icon: ScrollText },
        ].map((x) => (
          <Link key={x.to} to={x.to} className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-5 card-lift">
            <div className="h-10 w-10 rounded-lg bg-blue-50 flex items-center justify-center text-brand"><x.icon className="h-5 w-5" /></div>
            <span className="font-head font-semibold text-ink flex-1">{x.label}</span>
            <ArrowRight className="h-4 w-4 text-ink-muted" />
          </Link>
        ))}
      </div>
    </div>
  );
}
